<template>
  <div id="yext_dashboard">
    <h3>Yext</h3>
    <div class="backdrop" v-if="loading">
      <moon-loader :loading="loading" size="21px" color="#007bff" />
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>Location Details</h4>
        <div class="yext_details">
          <div class="inner-box" style="width: 600px">
            <input class="hl_input--wrap" type="text" placeholder="Enter Location ID" v-model="locationId" />
            <p v-if="entityDetailsError" class="error">
              {{ entityDetailsError }}
            </p>
          </div>
          <div>
            <button class="btn btn-primary unsub-btn" @click="getYextDetails()"
              :disabled="loading || locationId.trim() == ''">
              <span>Get Yext Details </span>
            </button>
          </div>
        </div>
        <div class="yext_details" v-if="yextDetails">
          <h5>Location Details</h5>
          <table>
            <tr>
              <td>Location Id</td>
              <td>{{ hlLocationId }}</td>
            </tr>
            <tr>
              <td>No. of Listings</td>
              <td>{{ entities.length }}</td>
            </tr>
          </table>
        </div>

        <div class="yext_details" v-if="entities.length">
          <h5>Listings Details</h5>
          <table>
            <tr>
              <th>Name</th>
              <th>Entity Id</th>
              <th>Listing Status</th>
              <th>Listing Created on</th>
              <th>Purchase Date</th>
              <th>Payment Status</th>
              <th>Purchase Type</th>
              <th>Price</th>
              <th>Subscription Id</th>
              <th>Days Passed</th>
            </tr>
            <tr v-for="entity in entities">
              <td>{{ entity.status !== "NOT_SUBMITTED" ? entity.name : "-" }}</td>
              <td>{{ entity.entityId }}</td>
              <td>{{ ['CANCELED', 'CONFLICT'].includes(entity.status) ? 'CONFLICTED' : entity.status }}</td>
              <td>{{ entity.listingsCreatedOn ? moment(entity.listingsCreatedOn).format('MM/DD/YYYY') : '-' }}</td>
              <td>{{ moment(entity.purchaseDate).format('MM/DD/YYYY') }}</td>
              <td>{{ entity.subscriptionId.startsWith('dummy-sub-') ? 'UNSUBSCRIBED' :
                locationSubscriptions[entity.subscriptionId]?.paymentStatus ?? "-" }}</td>
              <td v-if="!entity.subscriptionId.startsWith('dummy-sub-')">{{
                locationSubscriptions[entity.subscriptionId]?.purchaseStyle ?? "-" }}</td>
              <td v-if="!entity.subscriptionId.startsWith('dummy-sub-')">{{
                locationSubscriptions[entity.subscriptionId]?.amount ?? "-" }}</td>
              <td v-if="!entity.subscriptionId.startsWith('dummy-sub-')">{{ entity.subscriptionId }}</td>
              <td v-if="!entity.subscriptionId.startsWith('dummy-sub-')">{{
                moment().diff(moment(entity.purchaseDate).startOf('day'), 'days') }}</td>
            </tr>
          </table>
        </div>
        <div class="yext_details" v-if="yextDetails?.details?.agency">
          <h5>Agency Details</h5>
          <table>
            <tr v-if="yextDetails?.details?.agency?.id">
              <td>Agency Id</td>
              <td>{{ yextDetails.details.agency.id }}</td>
            </tr>
            <tr v-if="yextDetails?.companySubscriptions?.beneficiaries">
              <td>Yext Sold</td>
              <td>{{ yextDetails.companySubscriptions.beneficiaries.length }}</td>
            </tr>
            <tr v-if="yextDetails?.details?.agency?.stripeId">
              <td>Agency Stripe Id</td>
              <td>
                {{ yextDetails.details.agency.stripeId }}
              </td>
            </tr>
            <tr v-if="yextDetails?.companySubscriptions?.subscriptionId">
              <td>Subscription Id(s)</td>
              <td>
                {{
                  yextDetails.companySubscriptions.subscriptionId
                }}
              </td>
            </tr>
            <tr v-if="yextDetails?.companySubscriptions?.beneficiaries?.length">
              <td>All locations</td>
              <td>
                {{
                  Object.entries(agencyLocations)
                    .map(([beneficiary, count]) => `${beneficiary} (${count})`)
                    .join(', ')
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>Entity Details</h4>
        <div class="inner-box" style="text-align: left; width: 600px; display: flex; flex-direction: column; gap: 8px;">
          <input class="hl_input--wrap" type="text" placeholder="Enter Location ID" v-model="locationId" />
          <input class="hl_input--wrap" type="text" placeholder="Enter Entity ID" v-model="entityId" />
          <div v-if="entity" class="yext_details">
            <table>
              <tr>
                <td>Name</td>
                <td>{{ entity.status !== "NOT_SUBMITTED" ? entity.name : "-" }}</td>
              </tr>
              <tr>
                <td>Entity ID</td>
                <td>{{ entity.entityId }}</td>
              </tr>
              <tr>
                <td>Listing Status</td>
                <td>{{ entity.status }}</td>
              </tr>
              <tr>
                <td>Listing Created on</td>
                <td>{{ entity.listingsCreatedOn ? moment(entity.listingsCreatedOn).format('MM/DD/YYYY') : '-' }}</td>
              </tr>
              <tr>
                <td>Purchase Date</td>
                <td>{{ moment(entity.purchaseDate).format('MM/DD/YYYY') }}</td>
              </tr>
              <template v-if="!entity.subscriptionId.startsWith('dummy-sub-')">
                <tr v-if="locationSubscriptions[entity.subscriptionId]">
                  <td>Purchase Type</td>
                  <td>{{ locationSubscriptions[entity.subscriptionId].purchaseStyle }}</td>
                </tr>
                <tr v-if="locationSubscriptions[entity.subscriptionId]">
                  <td>Price</td>
                  <td>{{ locationSubscriptions[entity.subscriptionId].amount }}</td>
                </tr>
                <tr v-if="locationSubscriptions[entity.subscriptionId]">
                  <td>Subscription Id</td>
                  <td>{{ entity.subscriptionId }}</td>
                </tr>
              </template>
              <tr>
                <td>Payment Status</td>
                <td>{{ !entity.deleted && !entity.subscriptionId.startsWith('dummy-sub-') ?
                  locationSubscriptions[entity.subscriptionId]?.paymentStatus ?? "-" : 'UNSUBSCRIBED' }}</td>
              </tr>
              <tr v-if="entity.deleted && entity?.meta">
                <td>Life</td>
                <td>{{ `${entity.meta.life} Day(s)` }}</td>
              </tr>
            </table>
          </div>
          <button class="btn btn-primary unsub-btn" style="margin-top: 10px;" @click="getEntityDetails()"
            :disabled="loading || locationId.trim() == ''">
            <span>Get Entity Details</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>Unsubscribe Entity</h4>
        <div class="inner-box" style="text-align: left; width: 600px; display: flex; flex-direction: column; gap: 8px;">
          <input class="hl_input--wrap" type="text" placeholder="Enter Location ID" v-model="locationId" />
          <input class="hl_input--wrap" type="text" placeholder="Enter Entity ID" v-model="entityId" />
          <p v-if="responseStatus?.success" style="padding-left: 20px;" class="success">
            Entity unsubscribed successfully
          </p>
          <p v-if="error" class="error">
            {{ error }}
          </p>

          <button class="btn btn-primary unsub-btn" style="margin-top: 10px;" @click="unsubListing()"
            :disabled="loading || locationId.trim() == ''">
            <span>Unsubscribe Listing Entity</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>Hide Yext offer for all Locations</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input class="hl_input--wrap free-space" type="text" placeholder="Enter Company ID" v-model="companyId" />
          <p>
            This will disable Listings for all existing and future location for the Agency without any active Yext
          </p>
        </div>
        <div>
          <button class="btn btn-primary unsub-btn" @click="disableAllYext()"
            :disabled="loading || companyId.trim() == ''">
            <span> Disable All Yext </span>
          </button>
          <p class="success free-space" v-if="disableYextDetails">
            {{ disableYextDetails }}
          </p>
          <p class="error free-space" v-if="disableYextError">
            {{ disableYextError }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment";
import { SaasService, YextService, LocationsService, CompanyService } from "@/services"

export default {
  data: function () {
    return {
      moment,
      loading: false,
      idType: "location_id",
      locationId: "",
      companyId: "",
      error: "",
      stripePauseResponse: {
        status: null,
        message: null,
      },
      responseStatus: null,
      yextDetails: null,
      entityId: "",
      relationShipNumber: "",
      entityDeleteStatus: {
        type: null,
        message: "",
      },
      addManualYextIdStatus: '',
      orphanYextDeleteStatus: {
        type: null,
        message: "",
      },
      entities: [],
      locationSubscriptions: {},
      entity: null,
      entityDetailsError: "",
      agencyLocations: {},
      disableYextError: null,
      disableYextDetails: null,
      hlLocationId: ''
    };
  },
  components: {},
  methods: {
    async unsubListing() {
      this.loading = true;
      this.error = "";
      this.responseStatus = null;
      this.yextDetails = null;
      this.agencyLocations = {}
      this.entityDetailsError = ''
      this.entities = []
      this.entity = null
      this.disableYextDetails = null;
      this.disableYextError = null;
      this.companyId = ''
      try {
        await YextService.getLocationEntities({ locationId: this.locationId })
        const entity = await YextService.getListingEntity({
          locationId: this.locationId,
          entityId: this.entityId
        });
        if (!entity.data) {
          this.error = 'Location Id / Entity Id does not exist. Please check once again';
          this.loading = false;
          return
        }
        const response = await YextService.unsubscribeListingEntity({ locationId: this.locationId, entityId: this.entityId })
        this.responseStatus = {
          success: response.data.success
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.error = err.response.data.message;
        } else {
          this.error = err.message || err;
        }
      } finally {
        this.entityId = ''
      }
    },
    async getLocationConfiguration() {
      try {
        const locationConfig = await YextService.getLocationConfiguration(this.locationId)
        return locationConfig
      } catch (error) {
      }
    },
    async getLocationPaymentStatus() {
      try {
        const locationConfig = await YextService.getLocationPaymentStatus(this.locationId)
        return locationConfig
      } catch (error) {
      }
    },
    async getLocationSubscriptions() {
      try {
        const locationConfig = await YextService.getLocationSubscriptions(this.locationId)
        return locationConfig
      } catch (error) {
      }
    },

    async getYextDetails() {
      try {
        this.loading = true;
        this.error = "";
        this.responseStatus = null;
        this.yextDetails = null;
        this.agencyLocations = {}
        this.entityDetailsError = ''
        this.entities = []
        this.entity = null
        this.disableYextDetails = null;
        this.disableYextError = null;
        this.companyId = ''
        this.hlLocationId = ''
        let queryParam = null;
        queryParam = new URLSearchParams({
          location_id: this.locationId,
        });

        const locationData = await LocationsService.getLocationById(this.locationId)
        const companyId = locationData?.data?.location?.companyId
        const companyData = await CompanyService.getCompanyById(companyId)
        const companyStripeId = companyData?.data?.company?.stripeId

        const entities = await YextService.getLocationEntities({ locationId: this.locationId })
        const locationConfig = await this.getLocationConfiguration()
        const subscriptions = await this.getLocationSubscriptions()
        subscriptions.data.subscriptions.forEach((subscription) => {
          this.locationSubscriptions[subscription.subscriptionId] = subscription
        })
        this.yextDetails = {
          details: {
            agency: {
              id: companyId,
              stripeId: companyStripeId
            }
          }
        }
        this.yextDetails.config = locationConfig.data
        this.yextDetails.subscriptions = subscriptions.data.subscriptions
        this.hlLocationId = this.locationId
        const companySubscriptions = await YextService.getCompanySubscriptions({ companyId: this.yextDetails.details.agency.id })
        if (companySubscriptions.data.subscriptions.length) {
          this.yextDetails.companySubscriptions = companySubscriptions.data.subscriptions[0]
          this.yextDetails.companySubscriptions.beneficiaries.forEach((beneficiary) => {
            this.agencyLocations[beneficiary.id] = (beneficiary.id in this.agencyLocations ? this.agencyLocations[beneficiary.id] : 0) + 1
          })
        }
        this.entities = entities.data
      } catch (error) {
        this.entityDetailsError = "Please input valid sub-account id";
      } finally {
        this.entityId = ''
        this.loading = false;
      }
    },

    async getEntityDetails() {
      try {
        this.loading = true;
        this.yextDetails = null;
        this.agencyLocations = {}
        this.entityDetailsError = ''
        this.entity = null
        this.entities = []
        this.disableYextDetails = null
        this.disableYextError = null
        this.companyId = ''
        const entity = await YextService.getListingEntity({ locationId: this.locationId, entityId: this.entityId })
        const subscriptions = await this.getLocationSubscriptions()
        subscriptions.data.subscriptions.forEach((subscription) => {
          this.locationSubscriptions[subscription.subscriptionId] = subscription
        })
        this.entity = entity.data
      } catch (error) {
        console.log({ error })
      } finally {
        this.entityId = ''
        this.loading = false;
      }
    },

    async disableAllYext() {
      this.loading = true;
      this.yextDetails = null;
      this.agencyLocations = {}
      this.entityDetailsError = ''
      this.entity = null
      this.entities = []
      this.disableYextDetails = null
      this.disableYextError = null
      try {
        const company = await YextService.getCompanyDetails(this.companyId)
        if (company) {
          const companySubscriptions = await YextService.getCompanySubscriptions({ companyId: this.companyId })
          if (companySubscriptions.data.subscriptions.length > 0 && companySubscriptions.data.subscriptions[0].quantity > 0) {
            this.loading = false;
            this.disableYextDetails = "Cannot disable since company has active subscriptions"
            return
          }
          let response = await YextService.disableYextForAllLocations({
            companyId: this.companyId,
          });
          this.disableYextDetails = "Disabled All Yext Successfully"
        }
      } catch (err) {
        this.disableYextError = "Please enter a valid Agency Id";
      }
      this.loading = false;
    },
    toMoment(fsDate) {
      let date = moment();
      if (fsDate && fsDate._seconds) {
        date = moment.unix(fsDate._seconds);
      } else if (typeof fsDate === 'string') {
        date = moment(fsDate)
      }
      return date;
    },
    async pauseSubscriptionForStripeChange() {
      this.loading = true;
      this.error = "";
      this.stripePauseResponse = null;
      try {
        const saasRes = await SaasService.markYextUnsubscribeForStripe({
          relationship_number: this.relationShipNumber
        });
        this.stripePauseResponse = saasRes.data
        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.error = err.response.data.message;
        } else {
          this.error = err.message || err;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#yext_dashboard {
  position: relative;

  .checklist {
    padding: 20px;
  }

  .unsub-btn {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    margin: auto;
  }

  .error {
    color: #e53716;
    font-style: italic;
  }

  .warn {
    color: #ffc107;
  }

  .success {
    color: #28a745;
    font-style: italic;
    margin: 10px;
    background-color: #fff;
  }

  .yext_details {
    text-align: left;
    display: grid;
    justify-content: center;
    grid-gap: 20px;
    padding-top: 40px;

    .inline-child {
      /* background: aliceblue; */
      display: grid;
      justify-content: center;
      grid-auto-flow: column;
      grid-gap: 18px;
      padding: 10px;
    }

    table {
      border: 1px solid #e9e9e9;

      tr {
        th {
          padding: 5px 10px;
        }

        td {
          padding: 5px 10px;
        }

        td:first-child {}

        td:last-child {
          color: #4e4c4c;
        }
      }

      tr:nth-child(odd) {
        background: #f5f5f582;
      }
    }
  }

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffffa1;
    z-index: 100;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  .free-space {
    margin: 10px 0;
  }

  .center {
    text-align: center;
  }
}
</style>